<template>
  <el-select
    v-model="dataValue"
    :disabled="disabled"
    style="width: 100%;"
    placeholder="請選擇"
    @change="valueChange">
    <el-option
      v-for="item in options"
      :key="item.type_id"
      :label="item.name"
      :value="item.type_id"/>
  </el-select>
</template>
<script type="text/javascript">
import stringMixin from './stringMixin'

export default {
  name: 'XhBusinessStatus', // 商機狀態
  components: {},
  mixins: [stringMixin],
  props: {},
  data() {
    return {
      options: []
    }
  },
  computed: {},
  watch: {
    item: {
      handler(val) {
        if (val && val.data.setting) {
          this.options = val.data.setting
        } else {
          this.options = []
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    // 輸入的值
    valueChange(val) {
      /** 商機組順便回撥篩選數據 */
      this.$emit('value-change', {
        index: this.index,
        value: val,
        data: this.options
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
